<ng-container>
  <app-panel-header-image-view
    [pretitle]="athlete?.CountryShort"
    [logo]="true"
    [customTemplate]="false"
    [customTitleSet]="athlete != null ? true : false"
    [banner_image]="common_service.randomgImg | async"
    [downtitle]="athlete ? 'Age: ' + athlete?.Age + renderPositions(athlete) : undefined"
  >
    <div *ngIf="athlete" class="title">
      <div
        [ngClass]="{ 'title-hide': athlete == null }"
        class="localized-name"
        *ngIf="athlete?.GLocalizedName && athlete?.FLocalizedName"
      >
        (<lib-athlete-name
          [id]="athlete.Id"
          [wnameord]="athlete.WNameOrd"
          [gname]="athlete.GLocalizedName"
          [fname]="athlete.FLocalizedName"
        ></lib-athlete-name
        >)
      </div>
      <lib-athlete-name
        [ngClass]="{ 'title-hide': athlete == null }"
        class="common-name"
        [id]="athlete?.Id"
        [wnameord]="athlete?.WNameOrd"
        [gname]="athlete?.GName"
        [fname]="athlete?.FName"
      ></lib-athlete-name>
    </div>

    <app-third-nav-tab-component
      [elements]="common_service.routes"
    ></app-third-nav-tab-component>
    <img
      *ngIf="common_service.routes.length > 0 && athlete"
      class="pretitle"
      [lazyLoad]="'//extranet.worldarchery.sport/Flags/' + athlete?.NOC + '.svg'"
    />
    <div
      *ngIf="common_service.routes.length > 0 && athlete"
      class="banner__content__second__logo"
      @fadeInsight
    >
      <img
        (onLoad)="profilePhoto?.style.opacity=1; medals?.style.visibility='initial'"
        class="easeload"
        #profilePhoto
        [lazyLoad]="'//extranet.worldarchery.sport/ProfilePictures/?Id=' + athlete?.Id"
      />
<div style="visibility: hidden;" #medals>
<div class="insight-circle wrapper olympic">
      <ng-container
        *ngIf="
        (
        common_service?.athleteDetailStore?.olympic_medallist?.length > 0 ||
        common_service?.athleteDetailStore?.olympic_champion?.length > 0 ||
        common_service?.athleteDetailStore?.olympic_participant_logo?.length > 0
        )
        "
      >
      <ng-container
        *ngIf="
          common_service?.athleteDetailStore?.olympic_medallist.length > 0 ||
          common_service?.athleteDetailStore?.olympic_champion.length > 0
          else participant
        "
      >
      <img
        *ngIf="
        common_service?.athleteDetailStore?.olympic_champion.length > 0
        ||
        common_service?.athleteDetailStore?.olympic_medallist[0].Medals.Golds > 0
        ; else silver"
        class="insight-circle olympic gold"
        lazyLoad="../../../../modules/custom/wa_angular/app/assets/icons/insights_icons/olympic-logo-white.svg"
      />
      <ng-template #silver>
        <img
          *ngIf="common_service?.athleteDetailStore?.olympic_medallist[0].Medals.Silvers > 0; else bronze"
          class="insight-circle olympic silver"
          lazyLoad="../../../../modules/custom/wa_angular/app/assets/icons/insights_icons/olympic-logo-white.svg"
        />
      </ng-template>
      <ng-template #bronze>
        <img
          *ngIf="common_service?.athleteDetailStore?.olympic_medallist[0].Medals.Bronzes > 0"
          class="insight-circle olympic bronze"
          lazyLoad="../../../../modules/custom/wa_angular/app/assets/icons/insights_icons/olympic-logo-white.svg"
        />
      </ng-template>
    </ng-container>
    <ng-template #participant>
      <img
        class="insight-circle olympic participant"
        lazyLoad="../../../../modules/custom/wa_angular/app/assets/icons/insights_icons/name=olympic games.svg"
      />
    </ng-template>
      </ng-container>
    </div>
    <div class="insight-circle wrapper paralympic">
      <ng-container
        *ngIf="
        (
        common_service?.athleteDetailStore?.paralympic_champion?.length > 0 ||
        common_service?.athleteDetailStore?.paralympic_medallist?.length > 0 ||
        common_service?.athleteDetailStore?.paralympic_participant_logo?.length > 0
        )
        "
      >
        <ng-container
          *ngIf="
            common_service?.athleteDetailStore?.paralympic_medallist.length > 0
            ||
            common_service?.athleteDetailStore?.paralympic_champion.length > 0
            ;
            else paraparticipant
          "
        >
          <img
            *ngIf="
            common_service?.athleteDetailStore?.paralympic_champion.length > 0 ||
            common_service?.athleteDetailStore?.paralympic_medallist[0].Medals.Golds > 0
            ; else parasilver"
            class="insight-circle paralympic gold"
            lazyLoad="../../../../modules/custom/wa_angular/app/assets/icons/insights_icons/paralympic-logo-white.svg"
          />
          <ng-template #parasilver>
            <img
              *ngIf="common_service?.athleteDetailStore?.paralympic_medallist[0].Medals.Silvers > 0; else parabronze"
              class="insight-circle paralympic silver"
              lazyLoad="../../../../modules/custom/wa_angular/app/assets/icons/insights_icons/paralympic-logo-white.svg"
            />
          </ng-template>
          <ng-template #parabronze>
            <img
              *ngIf="common_service?.athleteDetailStore?.paralympic_medallist[0].Medals.Bronzes > 0"
              class="insight-circle paralympic bronze"
              lazyLoad="../../../../modules/custom/wa_angular/app/assets/icons/insights_icons/paralympic-logo-white.svg"
            />
          </ng-template>
        </ng-container>
        <ng-template #paraparticipant>
          <img
            class="insight-circle paralympic participant"
            lazyLoad="../../../../modules/custom/wa_angular/app/assets/icons/insights_icons/name=paraympic games.svg"
          />
        </ng-template>
      </ng-container>
    </div>
  </div>
    </div>
    <div></div>
  </app-panel-header-image-view>
  <app-google-ads [type]="'double_click_WA122_SANLIDA'"></app-google-ads>
  <app-app-content-page-wrapper>
    <div @fade *ngIf="athlete && loading === false; else loadingTemplate">
      <router-outlet></router-outlet>
    </div>
    <app-related-athletes-pannel
      appRouterHide
      [pathsToBeHide]="['biography']"
      @fade
      [isLoading]="common_service?.relatedAthletesStore?.loadingRef"
      *ngIf="
        athlete &&
        common_service?.relatedAthletes?.length > 0 &&
        common_service?.relatedAthletesStore.loadingRef === false
      "
      [title]="'RelatedAthletes' | transloco"
      [athletes]="common_service.relatedAthletes"
    ></app-related-athletes-pannel>
    <app-news-panel
      @fade
      appRouterHide
      [pathsToBeHide]="['news']"
      *ngIf="athlete != null"
      [title]="'related_news' | transloco"
      [news]="common_service.news"
    ></app-news-panel>
    <ng-template #loadingTemplate>
      <div
        class="loading-throbber"
        *ngIf="loading && error == false; else errorTemplate"
      ></div>
    </ng-template>
    <ng-template #errorTemplate>
      <ng-container *ngIf="error === true">
        <p>{{ errorMessage | transloco }}</p>
      </ng-container>
    </ng-template>
  </app-app-content-page-wrapper>
</ng-container>
